import React from 'react';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '../../../../../components/bootstrap/Modal_v2';
import Button from '../../../../../components/bootstrap/Button';
import { useTranslation } from 'react-i18next';

/**
 * 모바일 결재라인 선택 바텀시트 모달 (공통)
 *
 * @param {boolean}  isOpen
 * @param {Function} setIsOpen
 * @param {Array}    approvalList       - { id, name, lines, line, option, ccUsers }[]
 * @param {object}   selectedTemp       - 현재 임시 선택값
 * @param {Function} setSelectedTemp
 * @param {Function} onConfirm(item)    - 선택완료 클릭 시 호출 (formik setFieldValue 등)
 */
const ApprovalLineSelectModal = ({
	isOpen,
	setIsOpen,
	approvalList = [],
	selectedTemp,
	setSelectedTemp,
	onConfirm,
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			size='lg'
			isOpen={isOpen}
			setIsOpen={setIsOpen}
			className='select_bottom_pop'
			isScrollable
			isBottomed
		>
			<ModalHeader setIsOpen={setIsOpen} className='user-modal-header'>
				<ModalTitle>{t('결재라인')}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				{approvalList.map((item) => (
					<Button
						key={`approvalLineList-${item.id}`}
						className={`btn_select${selectedTemp?.id === item.id ? ' text-info' : ''}`}
						onClick={() => setSelectedTemp(item)}
					>
						{item.name}
					</Button>
				))}
			</ModalBody>
			<ModalFooter>
				<Button
					className='w-100 py-3'
					color='info'
					isDisable={!selectedTemp}
					onClick={() => {
						if (!selectedTemp) return;
						if (onConfirm) onConfirm(selectedTemp);
						setIsOpen(false);
					}}
				>
					<span>{t('선택완료')}</span>
				</Button>
			</ModalFooter>
		</Modal>
	);
};

export default ApprovalLineSelectModal;
